import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=8f5ba36e&scoped=true&"
import script from "./contract.vue?vue&type=script&lang=js&"
export * from "./contract.vue?vue&type=script&lang=js&"
import style0 from "./contract.vue?vue&type=style&index=0&lang=css&"
import style1 from "./contract.vue?vue&type=style&index=1&id=8f5ba36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5ba36e",
  null
  
)

export default component.exports